var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"face-overlay",style:(_vm.overlayStyle),on:{"click":function($event){return _vm.$emit('select', _vm.index)},"mouseenter":function($event){_vm.hovering = true},"mouseleave":function($event){_vm.hovering = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }